import { useEffect, useState, useRef } from "react";
import { notification } from 'antd';
import request from '@/utils/axios';

/**
 * @param {boolean} isICSCreated 
 * @param {number | string} id 
 */
export default function useIcal(isICSCreated, id) {
  const [iCalFile, setiCalFile] = useState(emptyICS);
  const fetched = useRef(false);

  useEffect(() => {
    if (fetched.current) return () => { }
    if (!id) return () => { }
    if (!(isICSCreated)) return () => { }

    getICS();
    fetched.current = true;
  }, [id, isICSCreated])

  const getICS = async () => {
    try {
      const response = await fetchICS(id);
      setiCalFile(response);
    } catch (error) {
      notification.error({
        message: 'Error',
        description: error instanceof Error ? error.message : 'Error fetching ICS',
      });
    }
  }

  return iCalFile
}

const emptyICS = { FileName: '', href: '', blob: false };

/** @param {number | string} id */
async function fetchICS(SitePageId) {
  const response = await request({
    url: 'attachment/downloadnsfile',
    method: 'POST',
    baseURL: process.env.V2_API_ROOT,
    responseType: 'blob',
    params: {
      area: 'c',
      id: SitePageId,
      folder: 'ics',
    },
    triggerLoad: false,
  });
  const fileName = response.headers['content-disposition']
    ? response.headers['content-disposition']
      .split('filename=')[1]
      .replace(/"([^"]+(?="))"/g, '$1')
    : `APCIA Event.ics`;
  const contentType = response.headers['content-type'];
  const blob = new Blob([response.data], { type: contentType, encoding: 'UTF-8' });
  const url = window.URL.createObjectURL(blob);

  return {
    FileName: fileName,
    href: url,
    blob,
  }
};